const VideoHLS = (() => {
  const initialized = new WeakSet();

  function waitForHls(callback) {
    if (window.Hls?.isSupported()) {
      callback(window.Hls);
    } else {
      setTimeout(() => waitForHls(callback), 50);
    }
  }

  function init(video, src, options = {}) {
    if (!video || !src || initialized.has(video)) return;
    initialized.add(video);

    const {
      autoplay = false,
      hideUntilReady = true,
      config = {},
      onReady = null,
      onError = null,
    } = options;

    waitForHls((Hls) => {
      if (!Hls.isSupported()) return;

      const hls = new Hls({
        enableWorker: true,
        capLevelToPlayerSize: false,
        autoLevelEnabled: false,
        autoStartLoad: false,
        ...config,
      });

      if (hideUntilReady) {
        video.style.visibility = "hidden";
        const reveal = () => {
          video.style.visibility = "visible";
          video.removeEventListener("playing", reveal);
        };
        video.addEventListener("playing", reveal);
      }

      hls.attachMedia(video);

      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        hls.startLevel = hls.levels.length - 1;
        hls.startLoad();

        if (autoplay) {
          video.play().catch(() => {});
        }

        onReady?.(video, hls);
      });

      hls.on(Hls.Events.ERROR, (event, data) => {
        if (data.fatal) {
          console.error("HLS fatal error:", data.type, data.details);
          onError?.(data);
          hls.destroy();
        }
      });

      hls.loadSource(src);
    });
  }

  function observe(selector = ".cloudflare_video", options = {}) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const video = entry.target;
          init(video, video.dataset.hlsSrc, options);
          observer.unobserve(video);
        }
      });
    });

    document.querySelectorAll(selector).forEach((video) => {
      observer.observe(video);
    });
  }

  return { init, observe };
})();

window.VideoHLS = VideoHLS;
